"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

exports.__esModule = true;
exports.waqi = void 0;

var E = __importStar(require("fp-ts/lib/Either"));

var TE = __importStar(require("fp-ts/lib/TaskEither"));

var fetchBy_1 = require("./fetchBy");

var normalize_1 = require("./normalize");
/**
 * @see https://wind.waqi.info/
 */


exports.waqi = {
  fetchByGps: fetchBy_1.fetchByGps,
  fetchByStation: function fetchByStation() {
    return TE.left(new Error('Unimplemented'));
  },
  id: 'waqi',
  name: 'WAQI',
  normalizeByGps: normalize_1.normalize,
  normalizeByStation: function normalizeByStation() {
    return E.left(new Error('Unimplemented'));
  }
};